import { BootstrapOptions, Component, EventEmitter, Inject, Input, LOCALE_ID, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Message, SelectItem, ConfirmationService, ConfirmEventType, MenuItem, MessageService, TreeNode } from 'primeng/api';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { TimePickerQuestion } from 'src/app/misc/component/dynamic-form/question-timepicker';
import { MultiSelectQuestion } from 'src/app/misc/component/dynamic-form/question-multiselect';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { ImageUploadQuestion } from 'src/app/misc/component/dynamic-form/question-imageupload';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { TextEditorQuestion } from 'src/app/misc/component/dynamic-form/question-editor';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { NumberQuestion } from 'src/app/misc/component/dynamic-form/question-number';



@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrl: './announcement.component.scss'
})
export class AnnouncementComponent {

  skelition = false;
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  messages: Message[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.announcementActionCall({ id: this.operationAnnouncement._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.announcementActionCall({ id: this.operationAnnouncement._id, action: 'Delete' })
      }
    }
  ];

  header = this.translate('Announcements');
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Announcements'), link: '/announcement' },
  ];
  stats: stat[] = [];

  translator: TranslatorPipe = new TranslatorPipe()
  @Output() newAnnouncement = new EventEmitter<any>();
  @Output() updateAnnouncements = new EventEmitter<any>();
  announcements: any[] = [];
  operationAnnouncement: any;
  statusOptions: any[] = [{ label: this.translate('active'), value: true }, { label: this.translate('Inactive'), value: false }]
  questions: QuestionBase<string>[] = [];
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  openCreateModal: boolean = false;
  checkboxValue: boolean = false;
  selectedAnnouncements: any[] = []
  operationType: any;
  templateSelectionList: any[] = [];
  users: any[] = [];

  treeData: TreeNode[] = [];
  allowedRight = ['Ministries/Entities', 'Organisational Units']
  currentDialog: any;
  questionBanksAll : any[] = [];
  allowedTags: string[] = this.permissionService.extractTags('ASSESSMENT_TAGS', 'r')

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private messageService: MessageService,
    private orgUnits: OrgUnitsService,
  ) { }
  
    ngOnInit() {
      this.skelition = true;
      Promise.all([this.getUsers(), this.getTreeData(), this.getAnnouncements()]).then(e => {
        this.getAllQuestionBanks();
        //this.makequestion();
        this.skelition = false;
      })
    }

    async getTreeData() {
      this.treeData = await this.orgUnits.getOrgUnitsMainPage(this.allowedRight);
    }

    flattenTree(root: TreeNode[]): any[] {
      const result: any[] = [];
      root.map(e => this.flattenNode(e, result))
      // this.flattenNode(root, result);
      return result;
    }
  
    private flattenNode(node: TreeNode, result: any[]): void {
      result.push((node as any)?._id);
      if (node.children) {
        for (const child of node.children) {
          this.flattenNode(child, result);
        }
      }
    }

    async getAllQuestionBanks() {
      try {
        let res = await this.dataService.postData(`question-bank/getAll/${this.allowedTags.join(',')}`,null);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        this.questionBanksAll = res.data;
      } catch (error) {
        console.log(error);
      }
    }

    translate(key: string) {
      let translator: TranslatorPipe = new TranslatorPipe();
      return translator.transform(key);
    }
  
    hasPermission(unit: string, flag: string) {
      return this.permissionService.hasPermission(unit, flag);
    }
  
    getAnnouncements = async () => {
      this.announcements = [];
      this.selectedAnnouncements = [];
      try {
        let res = await this.dataService.getData(`announcement/1/10`);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        this.announcements = res.data;

        this.announcements.forEach((announcement: any) => {
          announcement.targetUsers = announcement.targetUsers.map((user: any) => ({
            _id : user._id,
            name: this.getName(user.name) + ' ( '+ user.email +' )',
          }));
        });

        console.log("this.announcements",this.announcements);
        this.skelition = false;
      } catch (error) {
        console.log(error);
      }
    };
  
    createModal() {
      this.questions=[];
      this.makequestion();
      this.openCreateModal = true;
      this.currentDialog = "announcement"
    }

    createPopupAssessmentModal() {
      this.questions=[];
      this.makePopUpquestion();
      this.openCreateModal = true;
      this.currentDialog = "popup-quiz"
    }

    makePopUpquestion() {
      let today = new Date()
      today.setHours(0)
      today.setMinutes(0)
      today.setMilliseconds(0)
      this.questions = [
        new TextboxQuestion({
          key: 'name',
          label: this.translate('Name'),
          required: true,
          icon: 'pi pi-file',
          className: 'col-md-12 col-sm-12 col-12',
        }),

        new TextEditorQuestion({
          key: 'comments',
          label: 'الوصف',
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
        }),
  
        new DropdownQuestion({
          key: 'active',
          label: 'الحالة',
          options: [
            { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
            { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
          ],
          className: 'col-md-12 col-sm-12 col-12',
          value: true,
          visibility: "false",
  
        }),

        new MultiSelectQuestion({
          key: 'targetUsers',
          label: this.translate('Target Users'),
          options: this.users,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
        }),

        new TreeSelectQuestion({
          key: 'allowed_ou',
          label: this.translate('allowed ou'),
          treeOptions: this.treeData,
          order: 6,
          icon: 'pi pi-file',
          className: 'col-md-12 col-sm-12 col-12',
          filter: true,
          visibility: "true",
          selectionMode: "multiple"
        }),
  
        new TimePickerQuestion({
          key: 'startDate',
          label: 'تاريخ البدء',
          required: true,
          showTime: true,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
          value:  new Date(),
          touchUI: true
        }),
  
        new TimePickerQuestion({
          key: 'endDate',
          label: 'تاريخ الانتهاء',
          required: true,
          showTime: true,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
          touchUI: true,
          value: new Date(today.getFullYear() + 1, today.getMonth(), today.getDate(), 0, 0, 0)
        }),

        new DropdownQuestion({
          key: 'active',
          label: 'الحالة',
          options: [
            { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
            { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
          ],
          className: 'col-md-6 col-sm-12 col-12',
          value: true,
          visibility: "true",
        }),

        new DropdownQuestion({
          key: 'questionBankId',
          label: 'المسارات',
          options: this.questionBanksAll.map(e => { return { label: e.name + ' (' + e.tag.arabic + ')', value: e._id } }),
          className: 'col-12'
        }),

        new NumberQuestion({
          key: 'ignoreLimit',
          label: this.translate('Ignore Limit'),
          required: true,
          icon: 'pi pi-sort-numeric-down',
          className: 'col-md-6 col-sm-12 col-12',
        }),
      ];
    }
  
    makequestion() {
      let today = new Date()
      today.setHours(0)
      today.setMinutes(0)
      today.setMilliseconds(0)
      this.questions = [
        new TextboxQuestion({
          key: 'title',
          label: this.translate('Title'),
          required: true,
          icon: 'pi pi-file',
          className: 'col-md-12 col-sm-12 col-12',
        }),

        new TextEditorQuestion({
          key: 'description',
          label: this.translate('Description'),
          required: true,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
        }),

        new MultiSelectQuestion({
          key: 'targetUsers',
          label: this.translate('Target Users'),
          options: this.users,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
        }),

        new TreeSelectQuestion({
          key: 'allowed_ou',
          label: this.translate('allowed ou'),
          treeOptions: this.treeData,
          order: 6,
          icon: 'pi pi-file',
          className: 'col-md-12 col-sm-12 col-12',
          filter: true,
          visibility: "true",
          selectionMode: "multiple"
        }),
  
        new TimePickerQuestion({
          key: 'startDate',
          label: 'تاريخ البدء',
          required: true,
          showTime: true,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
          touchUI: true,
        }),
  
        new TimePickerQuestion({
          key: 'endDate',
          label: 'تاريخ الانتهاء',
          required: true,
          showTime: true,
          className: 'col-md-12 col-sm-12 col-12',
          visibility: "true",
          touchUI: true,
        }),

        new ImageUploadQuestion({
          key: 'image',
          label: this.translate('Image'),
          filetype:'ANNOUNCEMENTS',
          order: 10,
          isImage: true,
          required: false,
          className: 'col-md-6 col-sm-12 col-12',
          visibility: 'true',
        }),
  
        new DropdownQuestion({
          key: 'active',
          label: 'الحالة',
          options: [
            { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
            { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
          ],
          className: 'col-md-12 col-sm-12 col-12',
          value: true,
          visibility: "true",
        }),
      ];
    }
  
    openAnnouncementMenu(menu: any, event: any, announcement: any) {
      this.operationAnnouncement = announcement;
      menu.toggle(event);
    }

    receiveAnnouncementData = async ($event: any) => {
      try {
        let data = $event;
        if (data.allowed_ou)
        {
          data.ous = this.flattenTree(data.allowed_ou);
          delete data.allowed_ou;
        }
        console.log("data",data)

        if (data.startDate.getTime() > data.endDate.getTime() || data.endDate.getTime() < data.startDate.getTime()) {
          console.log("Start data should be less than end date 3");
          this.messageService.add({ 
            severity: 'error', 
            summary: this.translate('error'), 
            detail: this.translate('Start data should be less than end date') 
          });
          return;
        }
        
        data.startDate = formatDate(data.startDate, "dd-MM-YYYY HH:mm", this.locale);
        data.endDate = formatDate(data.endDate, "dd-MM-YYYY HH:mm", this.locale);
        if (data.targetUsers == '') {
          data.targetUsers = [];
        }
        console.log("Data 12",data);
  
        let res = await this.dataService.postData('announcement', data);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.DynamicFormComponent.resetForm();
        this.openCreateModal = false;
        this.ngOnInit()
      } catch (error) {
        console.log(error);
      }
    };
  
    updateAnnouncementData = async (event: any) => {
      try {
        let data: any = event;
        if (typeof data.startDate != 'string' && typeof data.endDate != 'string') {
          if (data.startDate.getTime() > data.endDate.getTime() || data.endDate.getTime() < data.startDate.getTime()) {
            this.messageService.add({ 
              severity: 'error', 
              summary: this.translate('error'), 
              detail: this.translate('Start data should be less than end date') 
            });
            return;
          }
        } else {
          if (data.startDate > data.endDate || data.endDate < data.startDate) {
            this.messageService.add({ 
              severity: 'error', 
              summary: this.translate('error'), 
              detail: this.translate('Start data should be less than end date') 
            });
            return;
          }
        }
        if (typeof data.startDate != 'string') {
          data.startDate = formatDate(data.startDate, "dd-MM-YYYY HH:mm", this.locale);
        }
        if (typeof data.endDate != 'string') {
          data.endDate = formatDate(data.endDate, "dd-MM-YYYY HH:mm", this.locale);
        }
        if (this.updateData) {
          data._id = this.updateData._id;
        }
        if (data.allowed_ou)
        {
          data.ous = this.flattenTree(data.allowed_ou);
          delete data.allowed_ou;
        }

        console.log("data",data);

        if (data.targetUsers == '') {
          data.targetUsers = [];
        }
        
        let res = await this.dataService.postData(
          'announcement',
          data,
          'PUT',
          false
        );
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.updateModal = false;
        this.updateData = undefined;
        // updating in table
        this.ngOnInit();
      } catch (error) {
        console.log(error);
      }
    };
  
    markAll() {
      this.announcements.forEach((s: any) => {
        s.selected = this.checkboxValue;
      });
      if (this.checkboxValue) {
        this.selectedAnnouncements = this.announcements;
      } else {
        this.selectedAnnouncements = [];
      }
    }
  
    async bulkDelete() {
  
      try {
        let ids = this.selectedAnnouncements.map((s: any) => s._id);
        let res = await this.dataService.postData(`announcement/bulkdelete`, { 'ids': ids }, 'POST', false);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.ngOnInit();
      } catch (error) {
        console.log(error);
      }
    }
  
    getTransformetdDate(date: string) {
      let dateArr = date.split('-').map(d => Number(d));
      let dateObj = new Date(dateArr[2], dateArr[1] - 1, dateArr[0])
      return new DatePipe(this.locale, 'Asia/Riyadh').transform(dateObj);
    }
  
    getTransformedDate(dateTime: string): string {
      const [datePart, timePart] = dateTime.split(' ');
      const [day, month, year] = datePart.split('-').map(Number);
      const dateObj = new Date(year, month - 1, day);
      let formattedDate = new DatePipe(this.locale, 'Asia/Riyadh').transform(dateObj);
      if (timePart) {
        const [hours, minutes] = timePart.split(':').map(Number);
        const timeObj = new Date(0, 0, 0, hours, minutes);
        const formattedTime = new DatePipe(this.locale).transform(timeObj, 'HH:mm');
        formattedDate += ' ' + formattedTime;
      }
      return formattedDate || '';
    }
  
    announcementActionCall($event: any) {
      switch ($event.action) {
        case 'Delete':
          this.confirm({
            message: this.translate('Are you sure you want to do this?'),
            header: this.translate('Confirmation message'),
            icon: 'pi pi-exclamation-triangle',
            action: () => {
              if ($event.bulk) {
                this.bulkDelete();
              } else {
                this.deleteAnnouncement($event.id);
              }
            },
          });
          break;
        case 'Update':
          this.updateData = this.operationAnnouncement;

          let selectedOU = this.findNodeById(this.treeData, this.updateData.ous.map((item: any) => item));
          console.log("this.updateData",this.updateData);
          this.updateQuestions = [
            new TextboxQuestion({
              key: 'title',
              label: this.translate('Title'),
              required: true,
              icon: 'pi pi-file',
              value: this.updateData.title,
              className: 'col-md-12 col-sm-12 col-12',
            }),
    
            new TextEditorQuestion({
              key: 'description',
              label: this.translate('Description'),
              required: true,
              className: 'col-md-12 col-sm-12 col-12',
              value: this.updateData.description,
              visibility: "true",
            }),
    
            new MultiSelectQuestion({
              key: 'targetUsers',
              label: this.translate('Target Users'),
              options: this.users,
              className: 'col-md-12 col-sm-12 col-12',
              value: this.updateData.targetUsers,
              visibility: "true",
            }),

            new TreeSelectQuestion({
              key: 'allowed_ou',
              label: this.translate('allowed ou'),
              treeOptions: this.treeData,
              order: 6,
              icon: 'pi pi-file',
              className: 'col-md-12 col-sm-12 col-12',
              filter: true,
              visibility: "true",
              selectionMode: "multiple",
              value: selectedOU,
            }),
      
            new TimePickerQuestion({
              key: 'startDate',
              label: 'تاريخ البدء',
              required: true,
              showTime: true,
              className: 'col-md-12 col-sm-12 col-12',
              visibility: "true",
              value: this.updateData.startDate,
              touchUI: true,
            }),
      
            new TimePickerQuestion({
              key: 'endDate',
              label: 'تاريخ الانتهاء',
              required: true,
              showTime: true,
              className: 'col-md-12 col-sm-12 col-12',
              visibility: "true",
              value: this.updateData.endDate,
              touchUI: true,
            }),

            new ImageUploadQuestion({
              key: 'image',
              label: this.translate('Image'),
              filetype:'ANNOUNCEMENTS',
              order: 10,
              isImage: true,
              required: false,
              className: 'col-md-6 col-sm-12 col-12',
              visibility: 'true',
              value: this.updateData?.image
            }),
      
            new DropdownQuestion({
              key: 'active',
              label: 'الحالة',
              options: [
                { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
                { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
              ],
              className: 'col-md-12 col-sm-12 col-12',
              value: this.updateData.active,
              visibility: "true",
            }),
          ];

          if(this.updateData.assessmentId) {
            this.updateQuestions.push(
              new NumberQuestion({
                key: 'ignoreLimit',
                label: this.translate('Ignore Limit'),
                required: true,
                icon: 'pi pi-sort-numeric-down',
                value: this.updateData.ignoreLimit,
                className: 'col-md-12 col-sm-12 col-12',
              }),
            )
          }
          this.updateModal = true;
          break;
        default:
          console.log('Unknown color');
          break;
      }
    }

    findNodeByName(data: any[], nodeName: any): any | undefined {
      for (const node of data) {
        if (node._id === nodeName) {
          return node;
        }
  
        if (node.children) {
          const result = this.findNodeByName(node.children, nodeName);
          if (result) {
            return result;
          }
        }
      }
  
      return undefined;
    }

    openResultsPage(announcement: any) {
      this.router.navigate(['/announcement/results/', announcement._id])
    }

    openAssessmentPage(announcement: any) {
      this.router.navigate(
        ['/assessment/add-question', announcement.assessmentId], 
        { queryParams: { QBankId: announcement.questionBankId, tabIndex: 0 } }
      );
    }    
  
    findNodeById(data: any[], nodeIds: any[]): any[] {
      const result: any[] = [];
  
      for (const nodeId of nodeIds) {
        const foundNode = this.findNodeByName(data, nodeId);
        if (foundNode) {
          result.push(foundNode);
        }
      }
  
      return result;
    }

    getUsers = async () => {
      try {
        const res = await this.dataService.getData('user/all');
        if (res.error) {
          return;
        }
        this.users = res.data.map((user: any) => ({
          _id : user._id,
          name: this.getName(user.name) + ' ( '+ user.email +' )',
        }));
      } catch (error) {
      }
    };
  
    getName(name: any) {
      if (!!name) {
        return name?.first + " " + name?.middle + " " + name?.last;
      }
      return "-"
    }
  
    deleteAnnouncement = async (id: string) => {
      try {
        let res = await this.dataService.deleteData(`announcement/${id}`);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.ngOnInit();
      } catch (error) {
        console.log(error);
      }
    };
  
    confirm(parems: any) {
      this.confirmationService.confirm({
        message: parems.message,
        header: parems.header,
        icon: parems.icon,
        acceptLabel: 'نعم',
        rejectLabel: 'لا',
        accept: () => {
          parems.action();
          return true;
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              return false;
            case ConfirmEventType.CANCEL:
              return false;
            default:
              return false;
          }
        },
      });
    }
  
    onDialogClose(){
    }
  
    async createAnnouncement() {
      await this.getAnnouncements();
      this.questions=[];
      this.makequestion();
      this.currentDialog = "announcement"
    }


    receiveAssessmentData = async ($event: any) => {
        try {
          let data = $event;
          data.testType = "popup-quiz";
    
          data.title = data.name;
          data.description = data.comments

          data.accessType = 'POPUP'
    
          if (data.startDate.getTime() > data.endDate.getTime() || data.endDate.getTime() < data.startDate.getTime()) {
            console.log("Start data should be less than end date 3");
            this.messageService.add({ 
              severity: 'error', 
              summary: this.translate('error'), 
              detail: this.translate('Start data should be less than end date') 
            });
            return;
          }
          data.startDate = formatDate(data.startDate, "dd-MM-YYYY HH:mm", this.locale);
          data.endDate = formatDate(data.endDate, "dd-MM-YYYY HH:mm", this.locale);
    
    
          let res = await this.dataService.postData('assessment', data);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }

          // Ensure assessmentId is assigned
          data.assessmentId = res.data._id;

          if (data.allowed_ou){
            data.ous = this.flattenTree(data.allowed_ou);
            delete data.allowed_ou;
          }
          
          if (data.targetUsers == '') {
            data.targetUsers = [];
          }
          console.log("Data 12",data);
          
          let res2 = await this.dataService.postData('announcement', data);
          if (res2.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }

          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];

          this.DynamicFormComponent.resetForm();
          this.openCreateModal = false;
          this.ngOnInit()
        } catch (error) {
          console.log(error);
        }
      };

}
